import React from 'react';
import styled from 'styled-components';
import { Box, ScreenReaderOnly, styles, Skeleton } from 'src/components/matchbox';
import { KeyboardArrowDown } from '@sparkpost/matchbox-icons';
import { tokens } from '@sparkpost/design-tokens';

const openStyles = ({ theme }) => `
  background: ${theme.colors.blue[700]};
  color: ${theme.colors.white};
`;

const closedStyles = ({ theme }) => `
  background: ${theme.colors.white};
  color: ${theme.colors.blue[700]};
`;

const DesktopAccountButton = styled.button`
  ${styles.buttonReset}
  ${styles.focusOutline({ radius: tokens.borderRadius_pill })}

  height:${({ theme }) => theme.sizes[650]};
  font-size: ${({ theme }) => theme.fontSizes[200]};
  border: 1px solid ${({ theme }) => theme.colors.blue[700]};
  border-radius: ${({ theme }) => theme.radii.pill};
  padding: ${({ theme }) => theme.space[200]} ${({ theme }) => theme.space[300]};
  cursor: pointer;
  transition: background ${({ theme }) => theme.motion.duration.fast},
    color ${({ theme }) => theme.motion.duration.fast};

  ${({ isOpen }) => (isOpen ? openStyles : closedStyles)}

  &:hover {
    ${openStyles}
  }
`;

function AccountButton(props) {
  const { currentUser, onClick, isOpen } = props;
  const { loading: isCurrentUserLoading, email } = currentUser;

  if (isCurrentUserLoading) {
    return <Skeleton.Box height="650" width="900" borderRadius="pill" />;
  }

  return (
    <DesktopAccountButton
      aria-controls="desktop-navigation-account-popover-contents"
      onClick={onClick}
      isOpen={isOpen}
      data-id="desktop-navigation-account-popover-trigger"
    >
      <Box
        display="inline-flex"
        alignItems="center"
        maxWidth={['900', null, null, null, '1000']}
        aria-hidden="true"
      >
        <Box truncate>{email}</Box>
        <Box size="20px">
          <KeyboardArrowDown size="20" />
        </Box>
      </Box>
      <ScreenReaderOnly>Account Menu</ScreenReaderOnly>
    </DesktopAccountButton>
  );
}

export default AccountButton;
